import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as Actions from 'actions';
class PostForm extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'PostForm';
        this.handleContentChange = this.handleContentChange.bind(this);
        this.handleExcerptChange = this.handleExcerptChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        console.log("Constructing PostForm");
        console.log(this.props);
    }
    componentDidMount() {
         $.FroalaEditor.DEFAULTS.key = 'VB-16wE-11tmhzC-21xD5B-13ol==';
        var connection = this.props.connection;

        var config = {
            requestHeaders : { token : connection.token },
            imageUploadParam : 'image',
            imageUploadURL : connection.url  + '/froala-file',
            imageUploadMethod: 'POST',
            toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', '|', 'color', 'emoticons', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', 'insertHR', '-', 'insertLink', 'insertImage', 'insertVideo', 'insertTable', 'undo', 'redo', 'clearFormatting', 'selectAll', 'html']
        };

        var editor = $('#content').froalaEditor(config);
        editor.on('froalaEditor.image.beforeUpload', (e,editor,images) => {
          console.log(e);
          debugger;
        })
        editor.on('froalaEditor.contentChanged',this.handleContentChange);
        editor.on('froalaEditor.image.error', (_, editor, error) => {
            console.error(error);
        })

    	var excerpt = $('#excerpt').froalaEditor(config);

        excerpt.on('froalaEditor.contentChanged',this.handleExcerptChange);
    }
    componentWillUnmount() {
        this.props.clearPost();
    }
    handleContentChange(e,editor) {

        var content = $('#content').froalaEditor('html.get');
        if(content) {
            this.props.updatePostContent(content);
            console.log("Set State with new content.");
            console.log(this.props.post);
        }

    }

    handleExcerptChange(e,editor) {

        var excerpt = $('#excerpt').froalaEditor('html.get');
        if(excerpt) {
            this.props.updatePostExcerpt(excerpt);
            console.log("Set State with new exerpt.");
            console.log(this.props.post);
        }

    }
    handleChange(e) {
        var prop = e.target.attributes.getNamedItem('name').value;
        var value = e.target.value;
        switch (prop) {
            case 'title':
                var title = value;
                var slug = (title.toLowerCase().match(/[a-zA-Z0-9\-]+/g)).join('-');
                if(slug) {
                    this.props.updatePostTitle(title);

                        this.props.updatePostSlug(slug);
                }

                break;
            case 'slug':
                var slug = value;
                if(slug)
                    this.props.updatePostSlug(slug);
                break;
        }
    }
    handleSave(e) {
        this.props.handleSave(this.props.post);
    }
    render() {
        console.log("PostForm Rendered.")
        if(this.props.post.content && this.props.post.content != $('#content').froalaEditor('html.get')) {
            $('#content').froalaEditor('html.set',this.props.post.content);
        }
        if(this.props.post.excerpt && this.props.post.excerpt != $('#excerpt').froalaEditor('html.get')) {
            $('#excerpt').froalaEditor('html.set',this.props.post.excerpt);
        }
        var slug = "";
        if(this.props.post.slug) {
            slug = this.props.post.slug.name;
        }
        return (
        	<div className="panel">
        		<div className="panel-heading">
					<div className="panel-title">
						<h2 className="panel-title">{this.props.heading}</h2>
					</div>
				</div>

        		<div className="panel-body">
        			<div className="row">
        				<div className="col-md-6 form-group">
        					<h2>Title</h2>
                            <p>The title of your post.</p>
        					<input name="title" type="text" className="form-control" placeholder="Title" onChange={this.handleChange} value={this.props.post.title} />
        				</div>
                        <div className="col-md-6 form-group">
                            <h2>Slug</h2>
                            <p>The url the user will see. </p>

                            <input name="slug" type="text" className="form-control" placeholder="slug-name" onChange={this.handleChange} readOnly="readonly" value={slug} />
                            <p>blog/post/{slug}</p>
                        </div>

        				<div className="col-md-12 form-group">
        					<h2>Content</h2>
                            <p>Enter your post content here.</p>
        					<textarea id="content" cols="50" className="form-control"></textarea>
        				</div>

                        <div className="col-md-12 form-group">
                            <h2>Excerpt</h2>
                            <p>Enter a small teaser for the blog post.</p>
                            <textarea id="excerpt" cols="50" className="form-control"></textarea>
                        </div>

                        <div className="col-md-4 col-offset-8 form-group">
                            <button onClick={this.handleSave} className="btn btn-lg btn-primary">Save</button>
                        </div>
        			</div>
        		</div>
        	</div>
        )
    }
}

var mapStateToProps = function(state) {
    return { post : state.post, connection:state.connection };
}


export default connect(mapStateToProps,Actions)(PostForm);



// WEBPACK FOOTER //
// ./src/browser/components/posts/PostForm.js